import { render, staticRenderFns } from "./IconSeasonalPromotion.vue?vue&type=template&id=67b39f49"
import script from "./IconSeasonalPromotion.vue?vue&type=script&lang=js"
export * from "./IconSeasonalPromotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports